import { KEYS } from "./constants";

interface EndPoints {
  [index: string]: any;
}
export const URL_ENDPOINTS: EndPoints = {
  HOME: {
    SHIPMENT_DETAILS: "web/v1/experience",
    ACTIVITY: "web/v1/experience",
    ACTION: "web/v1/experience",
    NUMBER_VALIDATION: "web/v1/experience",
    LOCATION: "web/v1/experience",
  },
  GLOBAL: {
    CONTENTORCONFIG: "web/v1/content-config",
  },
};

/**
 * To build request URL with provided inputs.
 * @param {string} endPoint URL category name.
 * @param {string} urlKey endpoint key name.
 * @param {*} value query string value to append to the url.
 */

export default function getURLDetails(
  endPoint: string,
  urlKey: string,
  value?: any
) {
  return {
    get_Service_Url: function () {
      let _url = "";
      const keyValue = URL_ENDPOINTS[endPoint][urlKey];
      const API_HOST = KEYS.API_HOST;
      if (keyValue) {
        _url = `https://${API_HOST}${keyValue}`;
        _url = value
          ? _url
              .replace("{upn}", value)
              .replace("{configEnv}", value)
              .replace("{vendorMessageID}", value)
          : _url;
      } else {
        throw new Error(
          "key value of End point URL is not matching with provided key name."
        );
      }
      return _url;
    },
  };
}
